import React, { useEffect, useState } from 'react';

const images = [
  '/Assets/LogoLoading0.svg',
  '/Assets/LogoLoading1.svg',
  '/Assets/LogoLoading2.svg',
  '/Assets/LogoLoading3.svg',
  '/Assets/LogoLoading4.svg',
  '/Assets/LogoLoading5.svg',
];

const primaryTextImages = [
  '/Assets/LoadingPrimaryText0.svg',
  '/Assets/LoadingPrimaryText1.svg',
  '/Assets/LoadingPrimaryText2.svg',
  '/Assets/LoadingPrimaryText3.svg',
  '/Assets/LoadingPrimaryText4.svg',
];

const Loading = ({ isLoading }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [primaryTextcurrentImageIndex, setprimaryTextCurrentImageIndex] = useState(0);
  const [contentLeftOffset, setContentLeftOffset] = useState(0);

  useEffect(() => {
    // Auto-detect main content's left offset
    const main = document.querySelector('main') || document.querySelector('.main-content');
    if (main) {
      const rect = main.getBoundingClientRect();
      setContentLeftOffset(rect.left);
    }

    if (isLoading) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    const interval = setInterval(() => {
      if (isLoading) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setprimaryTextCurrentImageIndex((prevIndex) => (prevIndex + 1) % primaryTextImages.length);
      }
    }, 500);

    return () => {
      clearInterval(interval);
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div
      className="fixed top-0 bottom-0 right-0 z-[9999] bg-white/60 backdrop-blur-sm flex items-center justify-center"
      style={{ left: `${contentLeftOffset}px` }}
    >
      <div className="flex flex-col items-center p-4 rounded-lg">
        <img
          src={'/Assets/loading.svg'}
          alt="Loading"
          style={{
            width: '70px',
            height: '70px',
            transition: 'opacity 0.5s ease-in-out',
          }}
        />
        <p className="text-primary font-bold mt-4">
          Loading{Array.from({ length: primaryTextcurrentImageIndex }).map((_, i) => (
            <span key={i}>.</span>
          ))}
        </p>
      </div>
    </div>
  );
};

export default Loading;
